import COUNTRIES from "../components/countries";
import {ColumnIds, IncludeExclude} from "../utils/types";
import {PublisherOrSiteOption,PageState,IdName,ProductRecord,CampaignRecord,CategoricalCellDto} from "../utils/types";
import {CampaignStatus,ProductsCampaignsDto,ResponseStatus} from "../utils/types";
import {TRAFFIC_TYPES_ARRAY} from "../utils/misc";
import StateHelper from "../utils/StateHelper";
import dayjs from "../utils/dayjs";
import { calculateISO8601WeekBoundaries } from "../utils/DateUtil";
import { DatagridHelper } from "./DatagridHelper";

function addTrafficSourceToState(pageState:PageState, categoricalCellDto:CategoricalCellDto, tmpValue:any): PageState {
    //- Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
    //reset state
    const elements : PublisherOrSiteOption[] = [];
    pageState.publishers = [];

    let value : string = null;
    if ( categoricalCellDto.columnId === ColumnIds.apptapPublisherName){
        value = categoricalCellDto.publisherId;
        if ( categoricalCellDto.publisherId !== null && categoricalCellDto.siteId !== null) {
            value += ":" + categoricalCellDto.siteId;            
        }
    }
    else {
        value = tmpValue;
    }

    if (categoricalCellDto.trafficSourceResponseDto) {
        for( let i = 0;  i < categoricalCellDto.trafficSourceResponseDto.publishersArray.length; i++ ){
            const element : PublisherOrSiteOption =  categoricalCellDto.trafficSourceResponseDto.publishersArray[i];
            if ( element.key === value ) {
                pageState.publishers.push(element.key);        
                elements.push(element);
                break;
            }
        }
    }
    return pageState;
}

function addCountryToState(pageState:PageState, value: any): PageState{
    pageState.countries = null;

    const elements : any[] = [];
    for( let i = 0;  i < COUNTRIES.length; i++ ){
        const element : any =  COUNTRIES[i];
        if ( element.id === value ) {
            pageState.countries = pageState.countries === null ? value : pageState.countries + "," + value;
            elements.push(element);
            break;
        }
    }
    return pageState;
}

function addSiteIdToState(pageState:PageState, categoricalCellDto: CategoricalCellDto, tmpValue:any): PageState {
    //reset state
    let elements : PublisherOrSiteOption[] = [];
    pageState.publishers = [];
    const publishersArray : PublisherOrSiteOption[] = categoricalCellDto.trafficSourceResponseDto ? categoricalCellDto.trafficSourceResponseDto.publishersArray : [];

    let keyValue : string = null;
    if( pageState.groupBy.includes(ColumnIds.apptapPublisherID)){
        //in this case the siteid must include the publisher id.
        keyValue = categoricalCellDto.publisherId + ":" + tmpValue;

        elements = publishersArray.filter((c : PublisherOrSiteOption) => c.key === keyValue);
    }
    else{
        //in this case, we should use ***:siteId , and include the item in the dropdown if it is not present.
        keyValue = "***:" + tmpValue;
        const pubArray : PublisherOrSiteOption[] = publishersArray.filter(( p : PublisherOrSiteOption) => p.key === keyValue);

        if( pubArray.length === 0){
            //For this situation, there is no corresponding entry in the dropdown - you would be creating a new entry specifically for this, 
            //with a labelKey like "<all publishers>:siteId"                
            const newElement : PublisherOrSiteOption = {
                record : {
                    apptapSiteId: tmpValue,
                    apptapPublisherSiteName: tmpValue,
                    apptapPublisherId: "***",
                    apptapPublisherName: "<All publishers>",
                    retired: false,
                    active: true
                },
                key: keyValue,
                id: keyValue,
                text: tmpValue
            };
            
            elements.push(newElement);

            //add the new element to the response.
            const newPublishersArray : PublisherOrSiteOption[] = [newElement, ...publishersArray];
            categoricalCellDto.setTrafficSourceResponseDto({ ...categoricalCellDto.trafficSourceResponseDto, newPublishersArray });       
        }
        else{
            elements.push(pubArray[0]);  
        }
    }


    //now add elements to state
    const trafficSourcesIdsArray : string[] = [];
    for( let i = 0;  i < elements.length; i++ ){
        const pub : PublisherOrSiteOption =  elements[i];
        trafficSourcesIdsArray.push(pub.key);
    }

    pageState.publishers = trafficSourcesIdsArray;
    return pageState;
}

function addTraffictypeToState(pageState:PageState, value:any): PageState {
    pageState.trafficTypes = null;

    const trafficTypesArray : IdName[] = [];

    const elements : any[] = [...trafficTypesArray];

    for( let i = 0;  i < TRAFFIC_TYPES_ARRAY.length; i++ ){
        const element : any =  TRAFFIC_TYPES_ARRAY[i];
        if ( element.id === value ) {
            pageState.trafficTypes = pageState.trafficTypes === null ? value : pageState.trafficTypes + "," + value;
            elements.push(element);
            break;
        }
    }
    return pageState;
}

function addProductIdToState(pageState:PageState, categoricalCellDto: CategoricalCellDto, value:any): PageState {
    if( categoricalCellDto.productsResponse ){    
        //- Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
        //reset state
        pageState.productIds = null;

        const elements : ProductRecord[] = [];
    
        for( let i = 0;  i < categoricalCellDto.productsResponse.length; i++ ){
            const product : ProductRecord =  categoricalCellDto.productsResponse[i];
            if ( product.productId === value ) {
                pageState.productIds = pageState.productIds === null ? value : pageState.productIds + "," + value;
                elements.push(product);
                break;
            }
        }
    }
    return pageState;
}

function addCampaignIdToState(pageState:PageState, categoricalCellDto: CategoricalCellDto, value:any): PageState {
    const page : string = categoricalCellDto.page;

// - Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
// - The filter for campaignID depends on what else the table is showing.
//  - If the table has campaignSource showing, then the filter would be source:campaignID
//  - If the table does not have campaignSource showing, then the filter would be ***:campaignID
//      - For this situation, there is no corresponding entry in the dropdown - you would be creating a new entry specifically for this, with a labelKey like "<all demand>:campaignID"


    if( categoricalCellDto.campaignsResponse && categoricalCellDto.campaignsResponse ){
        //- Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
        //reset state
        pageState.campaigns = [];

        let elements : CampaignRecord[] = null;

        if( pageState.groupBy.includes(ColumnIds.campaignSource)){
            //If the table has campaignSource showing, then the filter would be source:campaignID
            elements = categoricalCellDto.campaignsResponse.filter(function(c : CampaignRecord){
                return c.campaignId === value && c.campaignSource === categoricalCellDto.campaignSource;
            });
        }
        else{
            //If the table does not have campaignSource showing, then the filter would be ***:campaignID
            elements = categoricalCellDto.campaignsResponse.filter(function(c : CampaignRecord){
                return c.campaignId === value && c.campaignSource === "***";
            });

            if( elements.length === 0){
                //For this situation, there is no corresponding entry in the dropdown - you would be creating a new entry specifically for this, 
                //with a labelKey like "<all demand>:campaignID"                
                const newElement : CampaignRecord = {
                    id : value + ":***",
                    name : "***",
                    productId: null,
                    campaignSource: "***",
                    campaignSourceAlias: null,
                    campaignId: value,
                    campaignStatus: CampaignStatus.Active
                };
             
                elements.push(newElement);

                //add the new element to the response.
                const tmp : CampaignRecord[] = [newElement,...categoricalCellDto.campaignsResponse];

                const dto : ProductsCampaignsDto = {
                    status : ResponseStatus.OK, 
                    error : null,
                    productsResponse : categoricalCellDto.productsResponse,
                    campaignsResponse : tmp
                };

                const productsAndCampaignsForProductsPage = StateHelper.getProductsAndCampaignsState(page);
                productsAndCampaignsForProductsPage.dto = dto;
                categoricalCellDto.setProductsCampaignsDto(dto);
            }
        }

        const campaignIdsArray : string[] = [];
        for( let i = 0;  i < elements.length; i++ ){
            const campaign : CampaignRecord =  elements[i];
            campaignIdsArray.push(campaign.campaignSource + ":" + campaign.campaignId);
        }

        pageState.campaigns = campaignIdsArray;
    }
    return pageState;
}

function addCampaignSourceToState(pageState:PageState, categoricalCellDto:CategoricalCellDto, value:any): PageState {
//The filter for drilldown on campaignSource would always be: source:*** - e.g. sovrn:***

    const page : string = categoricalCellDto.page;

    if( categoricalCellDto.campaignsResponse ){
        //- Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
        //reset state
        pageState.campaigns = [];        
        let elements : CampaignRecord[] = [];
    
        //check if element exists in response from server
        const sourceToFind = value + ":***";
        const countArray : CampaignRecord[] = categoricalCellDto.campaignsResponse.filter(function (c : CampaignRecord){ return c.campaignId === "***" && c.campaignSource === value});
        const elementExistsInResponse : boolean = countArray.length > 0;

        if( elementExistsInResponse ){
            //element has already been searched in countArray.
            const campRecord : CampaignRecord = countArray[0];
            elements.push(campRecord);
            pageState.campaigns.push(campRecord.campaignSourceAlias);
        }
        else {
            const newElement : CampaignRecord = {
                id : sourceToFind,
                name : "***",
                productId: null,
                campaignSource: value,
                campaignSourceAlias: null,
                campaignId: "***",
                campaignStatus: CampaignStatus.Active
            };
         
            elements.push(newElement);

            //add the new element to the response.
            const tmp : CampaignRecord[] = [newElement,...categoricalCellDto.campaignsResponse];
            
            const dto : ProductsCampaignsDto = {
                status : ResponseStatus.OK, 
                error : null,
                productsResponse : categoricalCellDto.productsResponse,
                campaignsResponse : tmp
            };

            const productsAndCampaignsForProductsPage = StateHelper.getProductsAndCampaignsState(page);
            productsAndCampaignsForProductsPage.dto = dto;
            categoricalCellDto.setProductsCampaignsDto(dto);
        }
    }
    return pageState;
}

function addPublisherPlacementToState(pageState:PageState, categoricalCellDto:CategoricalCellDto, cellValue:any): PageState {
// To solve the confusion with traffic sources / placements and how they both affect the same filter - until we get a better UX in place - how about:
// - When no "placement" filter selected: Everything acts like it currently does. No change in behavior.
// - When there is a "placement" filter selected:
//      - Disable (and ignore) the traffic sources box (but keep the selected items visible)
//      - Filter is built ONLY from the placements box.
//      - (the user must "clear" the placements box to re-enable the traffic sources box)
//      - Add a message on the traffic sources box: "Clear Publisher Placements filter to filter by Traffic Sources"
    //reset state
    //clean both states
    pageState.publishers = [];
    pageState.placements = [];

    
    //Search in publishersReponse to get names.
    const groupByIncludesPublisherId : boolean = pageState.groupBy.includes(ColumnIds.apptapPublisherID);
    const groupByIncludesSiteId : boolean = pageState.groupBy.includes(ColumnIds.apptapSiteID);

    let apptapPublisherId : string = null;
    let apptapSiteId : string = null;
    let pĺacementKey : string = null;

    if( groupByIncludesPublisherId && groupByIncludesSiteId ){
        apptapPublisherId = categoricalCellDto.publisherId;
        apptapSiteId = categoricalCellDto.siteId;
        pĺacementKey = apptapPublisherId + ":" + apptapSiteId + ":" + cellValue;
    }
    else if( groupByIncludesPublisherId ){
        apptapPublisherId = categoricalCellDto.publisherId;
        apptapSiteId = "***";
        pĺacementKey = apptapPublisherId + ":***:" + cellValue;
    }
    else {
        //Since it is not grouped by, we don't have any names. 
        apptapPublisherId = "***";
        apptapSiteId = "***";
        pĺacementKey = "***:***:" + cellValue;
    }

    pageState.placements.push(pĺacementKey);
    return pageState;
}

function addCampaignSourceAliasToState(pageState:PageState, categoricalCellDto:CategoricalCellDto, value:any): PageState {
//The filter for drilldown on campaignSource would always be: source:*** - e.g. sovrn:***

    if( categoricalCellDto.campaignsResponse ){
        //- Whenever the user filters with the drill-down menu, the current filter should be replaced, not added to.    
        //reset state
        pageState.campaigns = [];        
    
        //check if element exists in response from server
        
        const countArray : CampaignRecord[] = categoricalCellDto.campaignsResponse
            .filter(function (c : CampaignRecord){ return c.campaignId === "***" && c.campaignSourceAlias === value});
        const elementExistsInResponse : boolean = countArray.length > 0;

        const sourceToFind = value + ":***" ;

        if( elementExistsInResponse ){
            //element has already been searched in countArray.

            pageState.campaigns.push(sourceToFind);
        }
        else {
            const newElement : CampaignRecord = {
                id : sourceToFind,
                name : "***",
                productId: null,
                campaignSource: null,
                campaignSourceAlias: value,
                campaignId: "***",
                campaignStatus: CampaignStatus.Active
            };

            //add the new element to the response.
            const tmp : CampaignRecord[] = [newElement,...categoricalCellDto.campaignsResponse];
            
            const dto : ProductsCampaignsDto = {
                status : ResponseStatus.OK, 
                error : null,
                productsResponse : categoricalCellDto.productsResponse,
                campaignsResponse : tmp
            };

            categoricalCellDto.setProductsCampaignsDto(dto);            
        }
    }
    return pageState;
}

function addDateRangeToState(pageState:PageState, cellValue:any): PageState {
    const date = dayjs.utc(cellValue);
    pageState.dateEnd = date;
    pageState.dateStart = date;
    return pageState;
}

function addMonthToState(pageState:PageState, cellValue:any): PageState {
    pageState.dateEnd = dayjs.utc(cellValue).endOf("month").startOf("day");
    pageState.dateStart = dayjs.utc(cellValue);
    return pageState;
}

function addWeekToState(pageState:PageState, cellValue:any): PageState {
    const [dateStart, dateEnd] = calculateISO8601WeekBoundaries(cellValue, "");
    pageState.dateEnd = dateEnd;
    pageState.dateStart = dateStart;
    return pageState;
}

function addCLinkIdOrOwnerToState(pageState:PageState, cellValue:any): PageState {
    const clinks:string[] = [];
    clinks.push(cellValue);
    pageState.cLinks = clinks;
    return pageState;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const addFilterToPageState = function(pageState:PageState, categoricalCellDto:CategoricalCellDto, value:any): PageState {
    const columnId : string = categoricalCellDto.columnId;

    switch( columnId ){
        case ColumnIds.date:
            pageState = addDateRangeToState(pageState, value);
            break;

        case ColumnIds.month:
            pageState = addMonthToState(pageState, value);
            break;

        case ColumnIds.week:
            pageState = addWeekToState(pageState, value);
            break;
    
        case ColumnIds.apptapPlacementID:
            break;

        case ColumnIds.apptapPublisherName:
        case ColumnIds.apptapPublisherID:
            pageState = addTrafficSourceToState(pageState, categoricalCellDto, value);
            pageState.placementsIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.apptapSiteID:
            pageState = addSiteIdToState(pageState, categoricalCellDto, value);
            pageState.placementsIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.publisherPlacementID:
            pageState = addPublisherPlacementToState(pageState, categoricalCellDto, value);
            pageState.placementsIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.country:
            pageState = addCountryToState(pageState, value);
            pageState.countriesIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.trafficType:
            pageState = addTraffictypeToState(pageState, value);
            pageState.trafficTypesIncludeExclude = IncludeExclude.Include;
            break;
                    
        case ColumnIds.productID:
            pageState = addProductIdToState(pageState, categoricalCellDto, value);
            pageState.productsIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.campaignID:
            pageState = addCampaignIdToState(pageState, categoricalCellDto, value);
            pageState.campaignsIncludeExclude = IncludeExclude.Include;
            break;

        case ColumnIds.campaignSource:
            pageState = addCampaignSourceToState(pageState, categoricalCellDto, value);
            break;

        case ColumnIds.campaignSourceAlias:
            pageState = addCampaignSourceAliasToState(pageState, categoricalCellDto, value);
            break;

        case ColumnIds.cLinkId:
        case ColumnIds.cLinkOwner:
            pageState = addCLinkIdOrOwnerToState(pageState, value);
            pageState.cLinksIncludeExclude = IncludeExclude.Include;
            break;
    }
    return pageState;
};

export const addFilterAndGroupByToPageState = function (pageState:PageState, categoricalFieldsDto:CategoricalCellDto, columnIdToGroupBy:string, value:any):PageState {
    pageState = addFilterToPageState(pageState, categoricalFieldsDto, value);

    let groupByArr = pageState.groupBy ? pageState.groupBy.split(",") : [];
    if ( columnIdToGroupBy === ColumnIds.date || columnIdToGroupBy === ColumnIds.month || columnIdToGroupBy === ColumnIds.week ){
        groupByArr = DatagridHelper.setSinglePeriodGroupBy(groupByArr, columnIdToGroupBy);
    } else {
        groupByArr.unshift(columnIdToGroupBy);
    }

    pageState.groupBy = groupByArr.join(",");
    return pageState;
};
